import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  VERIFY_EMAIL,
  IS_VERIFIED,
  LOGOUT,
  SET_MESSAGE,
  UPDATE_PROFILE,
  HIDE_MODAL,
  SHOW_REGISTER,
  SHOW_LOGIN,
  SHOW_MODAL,
} from "./types";

import AuthService from "../services/auth.service";

export const register = (username, email, password) => dispatch => {
  return AuthService.register(username, email, password).then(
    response => {
      dispatch({
        type: REGISTER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    error => {
      console.log(error);
      const errorData = error.response && error.response.data;
      const fieldErrors =
        errorData &&
        Object.entries(errorData).reduce(
          (errors, [fieldName, errorMessages]) => {
            errors[fieldName] = errorMessages.join("|");
            return errors;
          },
          {}
        );

      const message =
        Object.values(fieldErrors).join("|") ||
        errorData.non_field_errors ||
        error.message ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(message);
    }
  );
};

export const login = (username, password, rememberMe) => dispatch => {
  return AuthService.login(username, password, rememberMe).then(
    data => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    error => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.non_field_errors) ||
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(message);
    }
  );
};

export const verifyEmail = token => dispatch => {
  return AuthService.verifyEmail(token).then(
    data => {
      dispatch({
        type: VERIFY_EMAIL,
        payload: { is_verified: true },
      });

      return Promise.resolve({ is_verified: true });
    },
    error => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(message);
    }
  );
};
export const checkEmailStatus = () => dispatch => {
  return AuthService.checkEmailStatus().then(
    data => {
      dispatch({
        type: VERIFY_EMAIL,
        payload: { is_verified: data },
      });

      return Promise.resolve({ is_verified: data });
    },
    error => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(message);
    }
  );
};

export const isVerified = () => dispatch => {
  dispatch({
    type: IS_VERIFIED,
  });
  return AuthService.isVerified();
};

export const updateProfile = () => dispatch => {
  AuthService.updateProfile();

  dispatch({
    type: UPDATE_PROFILE,
  });
};

export const logout = () => dispatch => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};
// By default we show register
// export const showRegister = () => dispatch => {
//   dispatch({
//     type: SHOW_REGISTER,
//   });
// };
// export const showLogin = () => dispatch => {
//   dispatch({
//     type: SHOW_LOGIN,
//   });
// };
// export const hideModal = () => dispatch => {
//   dispatch({
//     type: HIDE_MODAL,
//   });
// };
// export const setShowModal = () => dispatch => {
//   dispatch({
//     type: SHOW_MODAL,
//   });
// };
